import "../css/header.scss";
import React, { useContext, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FiChevronDown,
  FiMenu,
  FiSearch,
  FiShoppingBag,
  FiX,
} from "react-icons/fi";
import { CartContext } from "./CartContext";
import siteConfig from "../siteConfig";

function Header() {
  const { cartItems } = useContext(CartContext);
  const [menuOpen, setMenuOpen] = useState(false);
  const [moreOpen, setMoreOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [query, setQuery] = useState("");
  const navigate = useNavigate();
  const count = useMemo(
    () => cartItems.reduce((sum, item) => sum + item.quantity, 0),
    [cartItems]
  );
  const closeMenu = () => {
    setMenuOpen(false);
    setMoreOpen(false);
    window.scrollTo(0, 0);
  };
  const go = () => {
    navigate(
      query.trim() ? `/shop?q=${encodeURIComponent(query.trim())}` : "/shop"
    );
    setSearchOpen(false);
    setQuery("");
    window.scrollTo(0, 0);
  };

  return (
    <>
      <div className="announcement">
        <span>FLAT RATE SHIPPING $9.99</span>
        <span>SECURE CHECKOUT · USD</span>
      </div>
      <header className="site-header">
        <div className="header-main">
          <button
            className="icon-button mobile-menu-button"
            onClick={() => setMenuOpen(true)}
            aria-label="Open menu"
          >
            <FiMenu />
          </button>
          <Link
            className="wordmark"
            to="/"
            onClick={closeMenu}
            aria-label={siteConfig.displayName}
          >
            <img src="/head/teingshome-logo.svg" alt="teingshome" />
          </Link>
          <nav
            className={`primary-nav ${menuOpen ? "is-open" : ""}`}
            aria-label="Main navigation"
          >
            <button
              className="menu-close"
              onClick={() => setMenuOpen(false)}
              aria-label="Close menu"
            >
              <FiX />
            </button>
            <Link to="/" onClick={closeMenu}>
              HOME
            </Link>
            <Link to="/shop" onClick={closeMenu}>
              NEW IN
            </Link>
            <Link to="/shop" onClick={closeMenu}>
              SHOP
            </Link>
            <Link to="/about" onClick={closeMenu}>
              ABOUT
            </Link>
            <Link to="/contact" onClick={closeMenu}>
              CONTACT
            </Link>
            <div className={`more-nav ${moreOpen ? "open" : ""}`}>
              <button
                type="button"
                onClick={() => setMoreOpen(!moreOpen)}
                aria-expanded={moreOpen}
              >
                MORE <FiChevronDown />
              </button>
              <div className="more-menu">
                <Link to="/privacy" onClick={closeMenu}>
                  PRIVACY POLICY
                </Link>
                <Link to="/cookies" onClick={closeMenu}>
                  COOKIE POLICY
                </Link>
                <Link to="/faqs" onClick={closeMenu}>
                  FAQS
                </Link>
                <Link to="/terms" onClick={closeMenu}>
                  TERMS
                </Link>
                <Link to="/shipping" onClick={closeMenu}>
                  DELIVERY
                </Link>
                <Link to="/returns" onClick={closeMenu}>
                  RETURNS
                </Link>
              </div>
            </div>
          </nav>
          <div className="header-actions">
            <button
              className="icon-button"
              onClick={() => setSearchOpen(true)}
              aria-label="Search"
            >
              <FiSearch />
            </button>
            <Link
              className="icon-button bag-link"
              to="/cartpage"
              aria-label={`Cart with ${count} items`}
            >
              <FiShoppingBag />
              <span>{count}</span>
            </Link>
          </div>
        </div>
      </header>
      {searchOpen && (
        <div
          className="search-overlay"
          role="dialog"
          aria-modal="true"
          aria-label="Search products"
        >
          <button
            className="search-close"
            onClick={() => setSearchOpen(false)}
            aria-label="Close search"
          >
            <FiX />
          </button>
          <form
            onSubmit={(event) => {
              event.preventDefault();
              go();
            }}
          >
            <label htmlFor="site-search">What are you looking for?</label>
            <div>
              <input
                id="site-search"
                autoFocus
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Search our store"
              />
              <button type="submit" aria-label="Submit search">
                <FiSearch />
              </button>
            </div>
          </form>
        </div>
      )}
    </>
  );
}

export default Header;
